import { Transaction } from 'prosemirror-state';
import TrackedStep, { TrackedStepJSON } from './TrackedStep';
import { Schema } from 'prosemirror-model';
import Commit, { CommitJSON } from './Commit';

export default class TrackState {
  commits;
  uncomittedTrackedSteps;
  constructor(uncomittedTrackedSteps, commits) {
    // The commit history
    // Steps and their maps corresponding to the changes that have been made since the last commit.
    this.uncomittedTrackedSteps = uncomittedTrackedSteps;
    this.commits = commits;
  }

  // Apply a transform to this state
  applyTransform(tx) {
    const trackedSteps = [];

    // Build a TrackedStep for each step
    tx.steps.forEach((step, i) => {
      const invertedStep = step.invert(tx.docs[i]);
      trackedSteps.push(new TrackedStep(step, invertedStep, tx.mapping.maps));
    });

    return new TrackState(this.uncomittedTrackedSteps.concat(trackedSteps), this.commits);
  }

  // When a transaction is marked as a commit, this is used to put any
  // uncommitted steps into a new commit.
  applyCommit(time) {
    if (this.uncomittedTrackedSteps.length === 0) return this;

    let commit = new Commit(time, this.uncomittedTrackedSteps);
    return new TrackState([], this.commits.concat(commit, []));
  }

  toJSON() {
    return {
      commits: this.commits.map(commit => commit.toJSON()),
      uncomittedTrackedSteps: this.uncomittedTrackedSteps.map(ts => ts.toJSON())
    };
  }

  static fromJSON(obj, schema) {
    return new TrackState(
      obj.uncomittedTrackedSteps.map(ts => TrackedStep.fromJSON(ts, schema)),
      obj.commits.map(commit => Commit.fromJSON(commit, schema))
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/client/editor-core/TrackState.js